export default () => ({ ak: 'iAqYq2ZdH0GbmtjOAktt', sk: 'mosTSzteyQyuA6Ed90vA3nHqgeqerKdm3GbaoNRv'})